// main.js
import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false
// 挂载全局变量到Vue实例
//获取语言
lg = localStorage.getItem("ageLanguage");
if(!lg)lg = "en";
Vue.prototype.$waitTime = 200;
//MsgBox.open("提示","开始全局初始化")
// 使用Promise替代async/await
async function connectWallet() {
	if (typeof window.ethereum !== 'undefined') {
		const selProvider = window.ethereum;
		// 请求用户授权连接
		const accounts = await selProvider.request({
		  method: 'eth_requestAccounts' 
		});
		let id =await selProvider.request({
			 method: 'eth_chainId',
		 });		 
		 if(Number(id) != Number(chainId)){
			 try{
				 await window.ethereum.request({
				     method: 'wallet_switchEthereumChain',
				     params: [{
				         chainId: chainId  // 十六进制格式的链ID
				     }]
				 });
				 MsgBox.open(Lang[lg]['t_8'], Lang[lg]['t_16']+ (id)+ Lang[lg]['t_17'] + (chainId),false,false);//"提示""当前网络Id=""，需要切换到"
			 }catch(e){
				 MsgBox.open(Lang[lg]['t_8'],Lang[lg]['t_18']+chainId+Lang[lg].t_19);
				 return;
			 }
			 
		 }
		 await onConnect(accounts);
		 // 监听账户变化
		 selProvider.on('accountsChanged', (accounts) => {
		 	
		 	onConnect(accounts);
		 });
		 
		 // 监听链变化
		 selProvider.on('chainChanged', (chainId) => {
		     MsgBox.open(Lang[lg]['t_8'],Lang[lg].t_20 +Number(chainId));//
		     window.location.reload();
		 });
	}else{
		await MsgBox.open(Lang[lg]['t_8'],Lang[lg].t_21);
	}
}
async function onConnect(accounts){
	
	try{
		web3 = new Web3(window.ethereum);
		Account = accounts[0];
		shortAccount = Account.substring(0,6)+"..."+Account.substring(38,42);
		
		conUSDT = new web3.eth.Contract(abiErc20, addrUSDT).methods;
		conATM = new web3.eth.Contract(abiErc20, addrATM).methods;
		conMine = new web3.eth.Contract(abiMine, addrMine).methods;
		conExc = new web3.eth.Contract(abiExc, addrExc).methods;
		conHis = new web3.eth.Contract(abiHistroy, addrBonus).methods;
		conCao = new web3.eth.Contract(abiCao, addrCao).methods;
		conBTL = new web3.eth.Contract(abiErc20, addrBTL).methods;
		conDeop = new web3.eth.Contract(abiDeop, addrDeop).methods;
	}catch(e){
		alert(e)
	}
	
}
connectWallet();
// 等待初始化完成后再挂载应用
new Vue({
	render: h => h(App),
}).$mount('#app')